import { StoreState } from '../../types';
import { FormattedErrors, SummaryData } from '../../../type/models';

export const getSummary = (state: StoreState): SummaryData => state.summary.summary;
export const getSummaryLoading = (state: StoreState): boolean => state.summary.isLoading;
export const getSummaryHasErrors = (state: StoreState): boolean => state.summary.hasErrors;
export const getSummaryErrors = (state: StoreState): FormattedErrors => state.summary.errors;
export const getSummaryStatus = (state: StoreState) => state.summary.status;
